import React from "react";
import {StyleDiv} from "./StyleDiv";
import {StyleLabel} from "./StyleLabel";
import {isAndroid} from "FirebaseUtils";
import GoBackButton from "components/Common/GoBackButton";

interface Props {
  onBackClick?: () => void;
  title?: string;
  titleStyle?: any;
  rightButton?: React.ReactNode;
}

function AndroidNavigationBar({onBackClick, title, titleStyle, rightButton}: Props) {
  if (!isAndroid) {
    return null;
  }

  return (
    <StyleDiv
      backgroundColor="var(--glass)"
      position="absolute"
      top="0"
      left="0"
      right="0"
      display="flex"
      width="100%"
      minHeight="60px"
      padding="10px 12px 10px 12px"
      boxSizing="border-box"
      alignItems="center"
      justifyContent="space-between"
      marginTop="0px"
      zIndex="9000"
      boxShadow="0 1px 0 var(--line)"
      style={{overflow: "visible", backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)"}}
    >
      {onBackClick ? (
        <GoBackButton onClick={onBackClick} inBarLayout marginTop="0" />
      ) : (
        <StyleDiv style={{width: "40px", flexShrink: 0}} />
      )}
      {title && (
        <StyleLabel
          fontSize="1.4rem"
          margin="0 auto"
          style={{
            fontFamily: "var(--font-display)",
            letterSpacing: "-0.01em",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            pointerEvents: "none",
            ...(titleStyle || {})
          }}
        >
          {title}
        </StyleLabel>
      )}
      {rightButton ? (
        <StyleDiv style={{marginLeft: "auto", display: "flex", alignItems: "center"}}>{rightButton}</StyleDiv>
      ) : (
        <StyleDiv style={{width: "40px"}} />
      )}
    </StyleDiv>
  );
}

export default AndroidNavigationBar;
